module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-down-ffe545d5193846b65ecd1dcf64e6af95.svg";